import React, { useState, useContext } from "react";
import axios from "axios";
import { ToastContext } from "../App";
import UserNavbar from "./userNavbar";

export default function ChangePassword() {
    const showToast = useContext(ToastContext);
    const [formData, setFormData] = useState({
        current_password: "",
        new_password: "",
        confirm_password: "",
    });
    const [loading, setLoading] = useState(false);

    const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/change-password`;

    const getAuthHeaders = () => {
        const token = localStorage.getItem("FORCE_GYM_TOKEN");
        return { headers: { Authorization: `Bearer ${token}` } };
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        if (formData.new_password !== formData.confirm_password) {
            showToast("كلمة المرور الجديدة وتأكيدها غير متطابقين!", "warning");
            return;
        }
        setLoading(true);
        try {
            const res = await axios.put(API_URL, formData, getAuthHeaders());
            showToast(res.data.message, "success");
            setFormData({ current_password: "", new_password: "", confirm_password: "" });

            localStorage.clear();
            window.location.href = "/login";

        } catch (err) {
            console.error(err);
            showToast("حدث خطأ أثناء تغيير كلمة المرور!", "danger");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container" dir="rtl" style={{ marginTop: "6rem", minHeight: "100vh" }}>
            <div className="d-flex justify-content-center align-items-center h-100">
                <div
                    className="card shadow-lg border-0 rounded-4 p-4 p-md-5"
                    style={{
                        maxWidth: "550px",
                        width: "100%",
                        background: "linear-gradient(145deg, #ffffff, #f0f4f7)",
                    }}
                >
                    <div className="text-center mb-4">
                        <h3 className="fw-bold text-primary mb-2">تغيير كلمة المرور</h3>
                        <p className="text-muted small">
                            أدخل كلمة المرور الحالية لتعيين كلمة مرور جديدة
                        </p>
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">كلمة المرور الحالية</label>
                        <input
                            type="password"
                            name="current_password"
                            value={formData.current_password}
                            onChange={handleChange}
                            placeholder="أدخل كلمة المرور الحالية"
                            className="form-control shadow-sm"
                            style={{ height: "50px" }}
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">كلمة المرور الجديدة</label>
                        <input
                            type="password"
                            name="new_password"
                            value={formData.new_password}
                            onChange={handleChange}
                            placeholder="أدخل كلمة المرور الجديدة"
                            className="form-control shadow-sm"
                            style={{ height: "50px" }}
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">تأكيد كلمة المرور الجديدة</label>
                        <input
                            type="password"
                            name="confirm_password"
                            value={formData.confirm_password}
                            onChange={handleChange}
                            placeholder="أدخل كلمة المرور الجديدة مرة أخرى"
                            className="form-control shadow-sm"
                            style={{ height: "50px" }}
                        />
                    </div>

                    <button
                        className="btn btn-primary w-100 fw-bold py-2 mt-3 shadow-sm"
                        onClick={handleSave}
                        disabled={loading}
                        style={{ borderRadius: "10px", transition: "0.3s" }}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                جاري الحفظ...
                            </>
                        ) : (
                            "تغيير كلمة المرور"
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}